/**
 * A country's name in the interface language, from its ISO 3166-1 alpha-2 code.
 *
 * Countries are stored by code — a strategy's holiday countries, a location's
 * feeder markets — so the name is free to follow the operator, and it comes
 * from the platform's locale data rather than from keys in `en.ts` and `cs.ts`.
 * A table names only the countries somebody typed into it, while the property's
 * location and its PMS can hand a screen any country at all; the table this
 * replaced was English besides, which is how "Czech Republic" and "Germany"
 * reached a Czech operator.
 *
 * Undefined for a code no country answers to, so a caller shows the code itself
 * rather than printing it twice. The platform lookup names nothing for a
 * lower-case code and throws on one that is not a region code at all, so the
 * code is trimmed and upper-cased first and anything but two letters is no
 * country.
 */
export function countryName(locale: string, code: string): string | undefined {
    const region = code.trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(region)) return undefined;
    return new Intl.DisplayNames(locale, { type: "region", fallback: "none" }).of(region);
}
